// CreateNewEvent.js

import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { createEvent } from '../../services/eventService';
import { getUserDetails } from '../../services/authService';
import '../../App.css';
import languageMap from '../languageMap';
import './create-new-event.css';

export default function CreateNewEvent(props) {
  const history = useHistory();
  const selectedLanguage = languageMap.config.selectedLanguage || 'en';

  // User & Event State
  const userId = localStorage.getItem("user_id");
  const [userData, setUserData] = useState(null);
  const [eventName, setEventName] = useState('');
  const [eventType, setEventType] = useState('');
  const [introImageUrl, setIntroImageUrl] = useState('');
  const [eventDate, setEventDate] = useState('');
  const [eventLocation, setEventLocation] = useState('');
  const [error, setError] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [popupText, setPopupText] = useState("");

  const DEFAULT_AVATAR = "/icons/default_user.png";
  const { username } = props.location.state || {};



  useEffect(() => {
    if (!userId) return;
    let cancel = false;
    (async () => {
      try {
        const res = await getUserDetails(userId);
        if (!cancel && res.success) {
          setUserData(res.user);
        }
      } catch (err) {
        console.error("Failed to fetch user:", err);
      }
    })();
    return () => { cancel = true; };
  }, [userId]);

  const handleCreateEvent = async () => {
    const user = username && username.trim() !== "" ? username : "0";
    const user_id = localStorage.getItem("user_id") || (username?.trim() || "0");
    console.log(user_id)
    try {
      let formattedDate = "";
      if (eventDate) {
        const d = new Date(eventDate);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        formattedDate = `${day}-${month}-${year}`;
      }

      await createEvent({
        user: user_id,
        user_id: user,
        event_name: eventName,
        event_type: eventType,
        intro_image_url: introImageUrl,
        event_date: formattedDate,
        event_location: eventLocation
      });

      setError(null);
      history.push(`/events`, { state: { username } });
    } catch (err) {
      console.error('Error creating event:', err);
      setError(languageMap.errorCreatingEvent[selectedLanguage]);
    }
  };

  const handlePopup = (text) => {
    setPopupText(text);
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const navigateTohome = () => {
    history.push("/events", {
      username: localStorage.getItem("registeredUsername") || "0",
    });
  };

  const handleBack = () => {
    history.goBack();
  };

  const handleUserClick = () => {
    if (!userId || !userData) return;
    history.push(`/user-details/${userId}`, {
      to_update: true,
      userData
    });
  };

  return (
    <div className="CreateNewEvent">
      <div className="logo-container-top">
        <div className="logo-container-event">
          {/* Back Button */}
          <img
            src='/icons/back.png'
            alt="Back"
            className="logo"
            onClick={handleBack}
            style={{ cursor: 'pointer' }}
          />
        </div>

        {/* User Icon */}
        <div
          className="user-image-container-event"
          onClick={handleUserClick}
          role="button"
          tabIndex={0}
          onKeyPress={(e) => e.key === "Enter" && handleUserClick()}
          style={{ cursor: "pointer" }}
        >
          <img
            src={userData?.photographer_profile?.image_url?.trim() || DEFAULT_AVATAR}
            alt="User"
            className="user-avatar"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = DEFAULT_AVATAR;
            }}
          />
        </div>
      </div>

      <div className="CreateNewEvent2">
        <div className="CreateNewEventTitle">{languageMap.createNewEventTitle[selectedLanguage]}</div>

        <div className="form-container">
          {error && <p>{error}</p>}

          <label>
            {languageMap.eventNameLabel[selectedLanguage]}
            <input
              type="text"
              value={eventName}
              onChange={(e) => setEventName(e.target.value)}
            />
          </label>

          <label>
          {languageMap.eventDateLabel ? languageMap.eventDateLabel[selectedLanguage] : 'תאריך האירוע'}
            <input
              type="date"
              value={eventDate}
              onChange={(e) => setEventDate(e.target.value)}
            />
          </label>

          <label>
          {languageMap.eventTypeLabel ? languageMap.eventTypeLabel[selectedLanguage] : 'טלפון בעל האירוע'}
            <input
              type="text"
              value={eventType}
              onChange={(e) => setEventType(e.target.value)}
            />
          </label>

          <label>
          {languageMap.eventLocationLabel ? languageMap.eventLocationLabel[selectedLanguage] : 'מיקום האירוע'}
            <input
              type="text"
              value={eventLocation}
              onChange={(e) => setEventLocation(e.target.value)}
            />
          </label>

          <label>
          {languageMap.introImageLabel ? languageMap.introImageLabel[selectedLanguage] : 'סוג האירוע'}
            <input
              type="text"
              value={introImageUrl}
              onChange={(e) => setIntroImageUrl(e.target.value)}
            />
          </label>
        </div>

        <button className="circular-button create-btn" onClick={handleCreateEvent}>
          שמור שינויים
        </button>
      </div>

      {/* Action Bar */}
      <div className="action-bar-create-event">
        <button className="action-item-event" onClick={navigateTohome}>
          <img src="/icons/home.png" alt="Home" className="action-icon-event" />
        </button>
      </div>

      {/* Popup */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup">
            <button className="popup-close-btn" onClick={closePopup}>
              &times;
            </button>
            <div className="popup-content">
              <img src="/icons/v.png" alt="Check" className="v-icon" />
              <span className="popupText">{popupText}</span>
              <img src="/icons/line_g.png" alt="Line" className="line-icon" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
